module.exports = __webpack_public_path__ + "static/media/thanks.e05eaec8.png";